import React from 'react';
import { Link } from 'react-router-dom';
import '../../Zone/zone.css';

function SanatanDharma() {
  return (
    <div style={{
      backgroundColor: 'black',
      minHeight: '100vh',
      padding: '20px 15px',
      color: 'white',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{
        textAlign: 'center',
        marginBottom: '40px',
        fontSize: '26px',
        textShadow: '0 0 8px #fff'
      }}>
        🕉️ Sanatan Dharma - Video Resource
      </h1>

      <div style={{
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 0 10px #222',
        maxWidth: '700px',
        margin: '0 auto 50px auto'
      }}>
        <iframe
          width="100%"
          height="300"
          src="https://www.youtube.com/embed/dUbsIdW04fc"
          title="Sanatan Dharma Video"
          frameBorder="0"
          style={{ display: 'block' }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link
          to="/zones"
          style={{
            backgroundColor: '#444',
            color: '#fff',
            padding: '10px 22px',
            borderRadius: '25px',
            textDecoration: 'none',
            fontSize: '14px',
            boxShadow: '0 0 5px #fff',
            transition: 'background 0.3s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#666'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#444'}
        >
          ⬅ Back to Museum Realms
        </Link>
      </div>
    </div>
  );
}

export default SanatanDharma;
